import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

import { IJbpSettingsApi } from '../../jbpSettings/models/jbpSettingsApi'

export const getJBPSettingsCrud = () => {
  return CrudStore.get(CrudStoreItemPartner360.JBPSettings) as Crud<IJbpSettingsApi>
}
